import type { Placements } from "@smartsuite/react-ui";
import { Colors, GrayColors, Icon, Tooltip } from "@smartsuite/react-ui";
import type { FC } from "react";
import { useState } from "react";
import * as S from "./style";

enum colors {
  regular = Colors.custom16,
  active = GrayColors["G-8"],
}

interface Props {
  tooltipText: string;
  placements?: Placements;
}

export const InfoIcon: FC<Props> = ({ tooltipText, placements }) => {
  const [colour, setColour] = useState<colors>(colors.regular);

  return (
    <S.IconWrapper>
      <Tooltip
        display="inline-flex"
        maxWidth={200}
        padding={0}
        placements={placements ?? ["top"]}
        text={tooltipText}
        target={
          <Icon
            name="info-filled"
            size="S"
            color={colour as unknown as string}
            onMouseEnter={() => setColour(colors.active)}
            onMouseLeave={() => setColour(colors.regular)}
          />
        }
      />
    </S.IconWrapper>
  );
};
